import { render, staticRenderFns } from "./InputLloodNumber.vue?vue&type=template&id=2bd39cb2&"
import script from "./InputLloodNumber.vue?vue&type=script&lang=js&"
export * from "./InputLloodNumber.vue?vue&type=script&lang=js&"
import style0 from "./InputLloodNumber.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports